// HoopFuel Hydration Quiz — Elevate Theme Version (Scoped, Comparison-free)
(function () {
  const section = document.getElementById('hoopfuel-quiz-section');
  if (!section) return;

  const q  = (sel, root = section) => root.querySelector(sel);
  const qa = (sel, root = section) => root.querySelectorAll(sel);

  const form   = q('#quizStage1');
  const stage1 = q('#quizStage1');
  const stage2 = q('#quizStage2');

  // Close button → Hydrate PDP
  const closeBtn = q('.quiz-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      window.location.href = 'https://hoopfuelnutrition.com/products/hoop-fuel-hydrate';
    });
  }

  // Accordion behavior
  (function initAccordions(){
    const headers   = qa('.accordion-header');
    const allBodies = qa('.accordion-body');

    function collapseAll() {
      allBodies.forEach(b => {
        b.classList.remove('open');
        b.style.maxHeight = null;
      });
      headers.forEach(h => h.classList.remove('active'));
    }

    headers.forEach(header => {
      header.addEventListener('click', function () {
        const card = header.closest('.accordion-card');
        const body = q('.accordion-body', card);
        const isOpen = body.classList.contains('open');

        collapseAll();
        if (!isOpen) {
          body.classList.add('open');
          header.classList.add('active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    // Expose collapseAll for session toggles
    section._collapseAllAccordions = collapseAll;
  })();

  // Session toggle behavior (Game / Practice / Rest)
  (function initSessionToggles(){
    const toggleButtons = qa('.toggle-btn');
    const gameCards = q('.game-cards');
    const restCards = q('.rest-cards');

    toggleButtons.forEach(button => {
      button.addEventListener('click', function () {
        toggleButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        const session = this.getAttribute('data-session');

        // Hide both sets
        if (gameCards) gameCards.style.display = 'none';
        if (restCards) restCards.style.display = 'none';

        // Collapse accordions
        if (section._collapseAllAccordions) section._collapseAllAccordions();

        // Show correct set
        const selectedSet = session === 'rest' ? restCards : gameCards;
        if (selectedSet) selectedSet.style.display = 'block';

        // Inject / refresh content for the chosen session
        injectReviewCard(session);

        // Reopen the review card only (delay to allow DOM reflow)
        setTimeout(() => {
          const reviewCard   = q('.review-card .accordion-body', selectedSet);
          const reviewHeader = q('.review-card .accordion-header', selectedSet);
          if (reviewCard && reviewHeader) {
            reviewCard.classList.add('open');
            reviewHeader.classList.add('active');
            reviewCard.style.maxHeight = reviewCard.scrollHeight + 'px';
          }
        }, 50);
      });
    });
  })();

  // Submit → calculate + show Stage 2 + send webhook
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Run calculations (custom event pattern preserved)
      const evt = new Event('calculateQuiz');
      form.dispatchEvent(evt);

      // Swap stages
      if (stage1) stage1.style.display = 'none';
      if (stage2) stage2.style.display = 'block';

      // Scroll into view
      section.scrollIntoView({ behavior: 'smooth' });

      // Send to Zapier
      setTimeout(() => {
        sendToZapierWebhook();
      }, 100);
    });
  }

  // ===== Calculations (unchanged logic) =====
  window.quizContext = {};

  if (form) {
    form.addEventListener('calculateQuiz', function () {
      const sex       = q('#sex')?.value;
      const heightIn  = parseInt(q('#height')?.value || '', 10);
      const weightLb  = parseInt(q('#weight')?.value || '', 10);
      const sweatRate = q('#sweatRate')?.value;

      if (isNaN(heightIn) || isNaN(weightLb)) {
        console.warn("❌ Missing or invalid height or weight. Quiz aborted.");
        return;
      }

      const weightKg = weightLb * 0.453592;
      const heightM  = heightIn * 0.0254;
      const bmi      = weightKg / (heightM * heightM);

      const genderMult = sex === 'female' ? 0.9 : 1.0;
      const sweatMult  = ({ low: 0.8, medium: 1.0, high: 1.2 })[sweatRate];
      const bmiMult    = Math.max(0.85, Math.min(bmi / 22, 1.15));

      const sweatLossL   = 1.0 * sweatMult * genderMult * bmiMult;
      const fluidLossOz  = Math.round(sweatLossL * 33.8 / 5) * 5;
      const bottles      = Math.round((fluidLossOz / 16) * 2) / 2;
      const sodiumLoss   = Math.round(sweatLossL * 1000 / 5) * 5;
      const potassiumLoss= Math.round(sweatLossL * 200 / 5) * 5;
      const magnesiumLoss= Math.round(sweatLossL * 15 / 5) * 5;
      const scoops       = Math.max(0.5, Math.ceil((sodiumLoss / 1000) * 2) / 2);

      const practiceFluid     = Math.round((fluidLossOz * 0.8) / 5) * 5;
      const practiceSodium    = Math.round((sodiumLoss * 0.8) / 5) * 5;
      const practicePotassium = Math.round((potassiumLoss * 0.8) / 5) * 5;
      const practiceMagnesium = Math.round((magnesiumLoss * 0.8) / 5) * 5;
      const practiceBottles   = Math.round((practiceFluid / 16) * 2) / 2;
      const practiceScoops    = Math.max(0.5, Math.ceil((practiceSodium / 1000) * 2) / 2);

      const restWaterOz     = Math.round(weightLb * (sex === 'male' ? 0.5 : 0.45) / 5) * 5;
      const restWaterBottles= Math.round((restWaterOz / 16) * 2) / 2;
      const restSodium      = 1800;
      const restPotassium   = 3200;
      const restMagnesium   = Math.round(weightKg * (sex === 'male' ? 5.2 : 5.0) / 5) * 5;

      window.quizContext = {
        sex,
        weightLb,
        heightIn,
        sweatRate,
        game: {
          fluidLossOz,
          bottles,
          sodium: sodiumLoss,
          potassium: potassiumLoss,
          magnesium: magnesiumLoss,
          scoops
        },
        practice: {
          fluidLossOz: practiceFluid,
          bottles: practiceBottles,
          sodium: practiceSodium,
          potassium: practicePotassium,
          magnesium: practiceMagnesium,
          scoops: practiceScoops
        },
        rest: {
          water: restWaterOz,
          bottles: restWaterBottles,
          sodium: restSodium,
          potassium: restPotassium,
          magnesium: restMagnesium
        }
      };

      // Default to game view content on submit
      injectReviewCard('game');
    });
  }

  // ===== DOM injection helpers (unchanged behavior, scoped) =====
  function injectReviewCard(sessionType) {
    const ctx = window.quizContext || {};
    const isRest = sessionType === 'rest';

    const root = isRest
      ? q('.rest-cards')
      : q('.game-cards');

    if (!root || !ctx[sessionType]) return;

    const data        = ctx[sessionType];
    const text        = q('.review-context-text', root);
    const sessionSpan = q('.review-session', root);
    const water       = q('.review-water', root);
    const bottles     = q('.review-bottles', root);
    const sodium      = q('.review-sodium', root);
    const potassium   = q('.review-potassium', root);
    const magnesiumLn = q('.review-magnesium-line', root);
    const magnesium   = q('.review-magnesium', root);
    const scoops      = q('.review-scoops', root);
    const scoopLine   = scoops?.closest('.review-line');

    // Show "target" icons only on the lines that matter
    const allLines = qa('.review-line', root);
    allLines.forEach(line => {
      const label = line.textContent.trim().toLowerCase();
      const iconLoss   = q('.icon-loss', line);
      const iconTarget = q('.icon-target', line);
      const showTarget = (
        label.startsWith('water') ||
        label.startsWith('sodium') ||
        label.startsWith('potassium') ||
        label.startsWith('magnesium')
      );
      if (iconLoss)   iconLoss.style.display   = showTarget ? 'inline-flex' : 'none';
      if (iconTarget) iconTarget.style.display = showTarget ? 'inline-flex' : 'none';
    });

    if (isRest) {
      if (water)    water.textContent    = data.water;
      if (bottles)  bottles.textContent  = data.bottles;
      if (sodium)   sodium.textContent   = data.sodium;
      if (potassium)potassium.textContent= data.potassium;
      if (magnesium)magnesium.textContent= data.magnesium;
      if (sessionSpan) sessionSpan.textContent = 'Rest Day';
      if (text) text.textContent = 'Recommended values follow the recommended daily allowance, adjusted based on your gender and weight.';
      if (magnesiumLn) magnesiumLn.style.display = 'block';
      return;
    }

    if (water)     water.textContent     = data.fluidLossOz;
    if (bottles)   bottles.textContent   = data.bottles;
    if (sodium)    sodium.textContent    = data.sodium;
    if (potassium) potassium.textContent = data.potassium;
    if (sessionSpan) sessionSpan.textContent = (sessionType === 'game' ? 'Game' : 'Practice/Pickup');
    if (text) text.textContent = 'Estimated losses are based on 1 hour of selected basketball workout type. Results are personalized based on your gender, height, weight, and sweat rate using the latest research.';

    if (typeof data.magnesium !== 'undefined' && magnesiumLn) {
      magnesiumLn.style.display = 'block';
      if (magnesium) magnesium.textContent = data.magnesium;
    }

    const scoopsWrapper = q('.review-scoops-wrapper', root);
    if (!isRest && scoopsWrapper) {
      const scoopValue  = data.scoops;
      const bottleCount = Math.ceil(scoopValue * 5);
      const unit        = scoopValue === 1 ? 'scoop' : 'scoops';
      const sessionLabel= sessionType === 'practice' ? 'Practice/Pickup' : 'Game';

      scoopsWrapper.innerHTML = `
        <div class="refuel-block">
          <div class="refuel-title">Your ${sessionLabel} Hydration Plan:</div>
          <div class="refuel-line">Use <strong>${scoopValue} ${unit} of HoopFuel Hydrate to replenish lost electrolytes</strong></div>
          <div class="refuel-line">*or ${bottleCount} bottles of Gatorade</div>
        </div>
      `;
    }
    if (scoopLine) scoopLine.style.display = 'block';
  }

  // Comparison card is intentionally not rendered; keep this as a no-op guard
  function populateComparisonCard() { /* intentionally empty */ }

  // Zapier webhook (unchanged)
  function sendToZapierWebhook() {
    const ctx   = window.quizContext;
    const email = q('#quizEmail')?.value;
    if (!ctx || !email) return;

    const formatScoops = (s) => `${s} ${s === 1 ? 'scoop' : 'scoops'}`;

    const payload = {
      email: email,

      game_water_loss_oz:        ctx.game.fluidLossOz,
      game_sodium_loss_mg:       ctx.game.sodium,
      game_potassium_loss_mg:    ctx.game.potassium,
      game_magnesium_loss_mg:    ctx.game.magnesium,
      game_scoops_text:          formatScoops(ctx.game.scoops),

      practice_water_loss_oz:    ctx.practice.fluidLossOz,
      practice_sodium_loss_mg:   ctx.practice.sodium,
      practice_potassium_loss_mg:ctx.practice.potassium,
      practice_magnesium_loss_mg:ctx.practice.magnesium,
      practice_scoops_text:      formatScoops(ctx.practice.scoops),

      rest_water_intake_oz:      ctx.rest.water,
      rest_sodium_intake_mg:     ctx.rest.sodium,
      rest_potassium_intake_mg:  ctx.rest.potassium,
      rest_magnesium_intake_mg:  ctx.rest.magnesium
    };

    const formData = new URLSearchParams();
    Object.entries(payload).forEach(([k, v]) => formData.append(k, v));

    fetch('https://hooks.zapier.com/hooks/catch/21153391/2jkp8ja/', {
      method: 'POST',
      body: formData
    }).catch(() => {});
  }

  // Expose for debugging if needed
  window._hfQuiz = { injectReviewCard };
})();
